window.__AllLang = ['en', 'ro', 'es', 'gr'];
window.langSelected = 'ro';// default language

window.__LANG_Obj = {
  ro: {
    // errorNotValidUrl: "URL-ul nu este valid",
    errorNotValidUrl: "Autentificare",
    enterCode: "Introdu codul",
    loading: "Incarcare...",

    automatRefund: 'Dorești returnarea automată a sumei?',
    automatRefundError: 'A apărut o eroare. Plata nu a fost returnată.',

    orderPickupDatetime: "Ora selectată de client este",
    addExtra: "Adaugă extra",
    done: "Fară timp suplimentar",
    minutes: "min",

    preparing: "ÎN PREGĂTIRE",
    prepared: "PREPARAT",

    headerBtn1: "Comenzi Noi",
    headerBtn2: "In procesare",

    footerBtn1: "Noi/Preluate",
    footerBtn2: "Pregatite",
    footerBtn3: "Finalizate",

    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    total_shipping: "Livrare",
    totals_tip: "Bacșiș",
    extras: "Ambalaj",
    callDriver: "Curier",
    cancelDriver: "Curier",
    cancel: "Anuleaza",
    packageCount: "Numar pachete DrCarmen",

    noTrackingNumber:
      "Numarul comenzii nu a fost gasit, curierul nu a fost anulat.",
    areYouSure: "Sigur vrei să chemi curier Glovo?",
    errorPickupTime: "Ora aleasă este înafară orarului de serviciu",
    outOfWorkingAreaDeliveryAddress:
      "Adresa de livrare este înafară ariei de serviciu",
    canNotCancel: "Comanda a fost deja preluată, livrarea nu poate fi anulată",
    CAN_NOT_CANCEL:
      "Comanda a fost deja preluată, livrarea nu poate fi anulată",
    addressesNotInSameCityCode: "Adresele nu sunt în același oraș",
    outOfWorkingHours: "Nici un curier nu este disponibil",
    outOfWorkingAreaPickupAddress:
      "Adresa de ridicare este înafara ariei de livrare",
    error: "A apărut o eroare",
    succes: "Succes!",
    yes: "Da",
    no: "Nu",
    callCourierCancel: "Sigur dorești să anulezi chemarea curierului?",
    courierTime: "Timp de ridicare colet: ",
    now: "Acum",
    print: "Printează",

    right: {
      question:
        "Prin continuarea utilizării aplicației vă dați acordul folosiri sunetului",
      btn: "De acord",
    },

    statuses: {
      PROCESSING: "PROCESARE",
      PREPARED: "PREPARATA",
      TRANSPORT: "TRANSPORT",
      DELIVERED: "LIVRATA",
      CANCELED: "ANULATA",
    },

    delivery_type: {
      PICK_UP: "RIDICARE",
      EAT_LOCATION: "REZERVARE",
      DELIVERY: "LIVRARE",
      MEET_HALF: "MEET_HALF",
      SELF_ORDERING: "MASĂ/KIOSK",
    },

    settings: "Setări",
    delivery: "Livrare",
    pickUp: "Ridicare",
  },
  en: {
    // errorNotValidUrl: "The url is not valid",
    errorNotValidUrl: "Authentication",
    enterCode: "Enter the code",
    loading: "Loading...",

    automatRefund: 'Do you want to refund amount automatically?',
    automatRefundError: 'Error. Order couldn\'t be refunded.',

    orderPickupDatetime: "Client selected",
    addExtra: "Add extra",
    done: "No extra time",
    minutes: "mins.",

    preparing: "PREPARING",
    prepared: "PREPARED",

    headerBtn1: "New",
    headerBtn2: "Processing",

    footerBtn1: "New",
    footerBtn2: "Ready",
    footerBtn3: "OLD",

    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    total_shipping: "Delivery",
    totals_tip: "Tip",
    extras: "Package",
    callDriver: "Driver",
    cancelDriver: "Driver",
    cancel: "Cancel",
    packageCount: "DrCarmen package count",

    noTrackingNumber: "No tracking number was found. Courier was not canceled",
    areYouSure: "Are you sure you want to call Glovo courier?",
    errorPickupTime: "Choosen pick up time is not available",
    outOfWorkingAreaDeliveryAddress: "Delivery address is not available",
    canNotCancel: "The order has been picked up already, it cannot be canceled",
    CAN_NOT_CANCEL:
      "The order has been picked up already, it cannot be canceled",
    addressesNotInSameCityCode: "Choosen addresses are not in the same city",
    outOfWorkingHours: "There are no couriers available at the moment",
    outOfWorkingAreaPickupAddress: "Pick up address is not available",
    error: "An error occurred",
    succes: "Success!",
    yes: "Yes",
    no: "No",
    callCourierCancel: "Are you sure to cancel courier call?",
    courierTime: "Courier pickup time: ",
    now: "Now",
    print: "Print",

    right: {
      question:
        "By continuing to use the application you agree to the use of sound",
      btn: "Yes I want to continue",
    },

    statuses: {
      PROCESSING: "PROCESSING",
      PREPARED: "PREPARED",
      TRANSPORT: "TRANSPORT",
      DELIVERED: "DELIVERED",
      CANCELED: "CANCELED",
    },

    delivery_type: {
      PICK_UP: "PICK UP",
      EAT_LOCATION: "LOCATION",
      DELIVERY: "DELIVERY",
      MEET_HALF: "MEET_HALF",
      SELF_ORDERING: "TABLE/KIOSK",
    },

    settings: "Settings",
    delivery: "Delivery",
    pickUp: "Pick Up",
  },
  es: {
    // errorNotValidUrl: "The url is not valid",
    errorNotValidUrl: "Authentication",
    loading: "Cargando...",

    orderPickupDatetime: "Hora seleccionada por el cliente",
    addExtra: "Agregar extra",
    done: "Sin tiempo extra",
    minutes: "minutos",

    headerBtn1: "Nueva",
    headerBtn2: "Procesando",

    footerBtn1: "Nueva",
    footerBtn2: "Lista",
    footerBtn3: "ANTIGUA",

    total: "Total",
    subtotal: "Total parcial",
    discount: "Descuento",
    total_shipping: "Entrega",
    totals_tip: "Propina",
    extras: "Paquete",

    right: {
      question:
        "Al continuar utilizando la aplicación, acepta el uso del sonido.",
      btn: "Si quiero continuar",
    },

    statuses: {
      PROCESSING: "PROCESANDO",
      PREPARED: "PREPARADA",
      TRANSPORT: "TRANSPORTE",
      DELIVERED: "ENTREGADA",
      CANCELED: "CANCELADA",
    },

    delivery_type: {
      PICK_UP: "RECOGER",
      EAT_LOCATION: "UBICACIÓN",
      DELIVERY: "ENTREGA",
      MEET_HALF: "A LA MITAD",
      SELF_ORDERING: "MESA",
    },

    settings: "Ajustes",
    delivery: "Entrega",
    pickUp: "Levantar",
  },
  gr: {
    errorNotValidUrl: "Η διεύθυνση URL δεν είναι έγκυρη",
    loading: "Φόρτωση...",

    headerBtn1: "Νέος",
    headerBtn2: "Επεξεργασία",

    footerBtn1: "Νέος",
    footerBtn2: "Ετοιμος",
    footerBtn3: "ΠΑΛΑΙΟΣ",

    orderPickupDatetime: "Επιλέχθηκε ο πελάτης",
    addExtra: "Προσθέστε επιπλέον",
    done: "Χωρίς επιπλέον χρόνο",
    minutes: "λεπτά.",

    total: "Σύνολο",
    subtotal: "ΜΕΡΙΚΟ ΣΥΝΟΛΟ",
    discount: "Εκπτωση",
    total_shipping: "Διανομή",
    totals_tip: "Υπόδειξη",
    extras: "πακέτο",

    right: {
      question:
        "Συνεχίζοντας να χρησιμοποιείτε την εφαρμογή, αποδέχεστε τη χρήση του ήχου",
      btn: "Ναι θέλω να συνεχίσω",
    },

    statuses: {
      PROCESSING: "ΕΠΕΞΕΡΓΑΣΙΑ",
      PREPARED: "ΕΤΟΙΜΟΣ",
      TRANSPORT: "ΜΕΤΑΦΟΡΑ",
      DELIVERED: "ΠΑΡΑΔΟΘΗΚΕ",
      CANCELED: "ΑΚΥΡΩΘΗΚΕ",
    },

    delivery_type: {
      PICK_UP: "ΜΑΖΕΥΩ",
      EAT_LOCATION: "ΤΟΠΟΘΕΣΙΑ",
      DELIVERY: "ΔΙΑΝΟΜΗ",
      MEET_HALF: "ΣΤΑ ΜΙΣΆ",
      SELF_ORDERING: "ΤΡΑΠΕΖΙ",
    },
    
    settings: "Ρυθμίσεις",
    delivery: "Διανομή",
    pickUp: "Μαζεύω",
  },
};

window.__LANG = window.__LANG_Obj[window.langSelected]; 
